import { useAuth } from "@/contexts/auth/useAuth";

import { useFeatures } from "./useFeatures";

interface UsePremiumProps {
  hasPremium: boolean;
  isPremiumEligible: boolean;
}

const usePremium = (): UsePremiumProps => {
  const { currentAccount } = useAuth();
  const features = useFeatures();

  const hasPhoneSet = currentAccount?.source.sms;
  const signUpCountry = currentAccount?.source.sms_country;

  // // If no sms set, assume they signed up in the US
  const unitedStatesUser = signUpCountry === "US" || !hasPhoneSet;

  const hasPremium = features.premium && (currentAccount?.premium || false);
  const isPremiumEligible = features.premium && !hasPremium && unitedStatesUser;

  return {
    hasPremium,
    isPremiumEligible,
  };
};

export { usePremium };
